import { Box, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import InputMascarado from "../../input-mascarado/InputMascarado";
import Input from "../../input/input";
import { mascaraCep } from "../../../../utils/mascaras";
import { BuscarCEP } from "../../../buscarCEP/buscar-CEP";

interface EnderecoFormProps {
  methods: UseFormReturn<any>;
  disabled?: boolean;
  mdDown?: any;
}

export function EnderecoFormPart({
  methods,
  mdDown,
  disabled = false,
}: EnderecoFormProps) {
  return (
    <Box>
      <Typography variant="h5" padding="20px 0">
        Endereço:
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns={mdDown ? "1fr" : "1fr 1fr 1fr"}
        gap="20px"
        width="100%"
        flexWrap="wrap"
      >
        <BuscarCEP methods={methods} disabled={disabled} />
        <Input
          name="address.number"
          label="Número"
          methods={methods}
          disabled={disabled}
        />
        <Input
          name="address.street"
          label="Rua"
          methods={methods}
          disabled={disabled}
        />

        <Input
          name="address.neighborhood"
          label="Bairro"
          methods={methods}
          disabled={disabled}
        />
        <Input
          name="address.city"
          label="Cidade"
          methods={methods}
          disabled={disabled}
        />
        <Input
          name="address.state"
          label="Uf"
          methods={methods}
          disabled={disabled}
        />
        <Input
          name="address.complement"
          label="Complemento"
          methods={methods}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
}
